import { render, staticRenderFns } from "./LikeIcon.vue?vue&type=template&id=2c25ba85&scoped=true&"
import script from "./LikeIcon.vue?vue&type=script&lang=js&"
export * from "./LikeIcon.vue?vue&type=script&lang=js&"
import style0 from "./LikeIcon.vue?vue&type=style&index=0&id=2c25ba85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25ba85",
  null
  
)

export default component.exports